import {
  toast, ToastOptions, ToastContainerProps, TypeOptions, ToastPosition,
} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Backwards compatibility for toast.TYPE and toast.POSITION (removed in react-toastify v10+)
const toastWithType = toast as typeof toast & {
  TYPE: {
    INFO: TypeOptions;
    SUCCESS: TypeOptions;
    WARNING: TypeOptions;
    ERROR: TypeOptions;
    DEFAULT: TypeOptions;
  };
  POSITION: {
    TOP_LEFT: ToastPosition;
    TOP_RIGHT: ToastPosition;
    TOP_CENTER: ToastPosition;
    BOTTOM_LEFT: ToastPosition;
    BOTTOM_RIGHT: ToastPosition;
    BOTTOM_CENTER: ToastPosition;
  };
};

toastWithType.TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default',
};

toastWithType.POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center',
};

export function superAdminToast(isVaultSuperAdmin: boolean, message: any, options: ToastOptions) {
  if (!isVaultSuperAdmin) {
    toastWithType(message, options);
  }
}

// ToastContainer props to be used in App.tsx
export const toastContainerProps: ToastContainerProps = {
  autoClose: 5000,
  draggable: false,
  position: 'top-center',
  theme: 'colored',
  style: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: 0,
    transform: 'translateX(-50%)',
    width: 'auto',
    whiteSpace: 'pre-line',
    textAlign: 'center',
  },
  toastStyle: {
    fontSize: '18px',
    minWidth: '320px',
    padding: '15px',
    textAlign: 'center',
  },
};

export default toastWithType;
